<template>
	<div id="userlogin">
		<div class="bm_h">
			<h3> 登录</h3>
		</div>

		<Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80">
			<!-- <Row type="flex" justify="center" align="middle">
				<Col   align="right">
					<FormItem label="快捷登录" >
				  <img id="weixin-logo" :src="require('@/assets/image/element/weixin.png')">  
				  </FormItem>
				</Col>
				 
			</Row> -->
			<Row type="flex" justify="center" align="middle">
				<Col   align="right">
				<FormItem label="用户名" prop="loginId">
					<Input v-model="formValidate.loginId" placeholder="用户名"></Input>
					 
				</FormItem>
				</Col>
				 
			</Row>
			<Row type="flex" justify="center" align="middle">
				<Col   align="right">
				<FormItem label="密码" prop="password">
					<Input v-model="formValidate.password" type="password"></Input>
				</FormItem>

				</Col>
			</Row>
			<Row type="flex" justify="center" align="middle">
				<Col   >
				<FormItem label="验证码" prop="valid">
					<Input id='valid' v-model="formValidate.valid" placeholder="验证码"> </Input>
					<img id='imageId' :src="this.verificationImg" @click="changeImage">
				</FormItem>
				</Col>
			</Row>
			<Row justify="center" align="middle">
				 
				<FormItem>
					<!-- 	{{$store.state.userInfo.userName}}  -->
					<Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
					<Button @click="handleReset('formValidate')" style="margin-left: 20px">重置</Button>
				</FormItem>
			 
			</Row>
		</Form>

	</div>
</template>


<script>
	import {
		getValidImage,
		getSession,
		login
	} from '@/network/index.js';

	export default {
		name: 'Login',
		components: {

		},
		data() {


			return {
				formValidate: {
					loginId: '',
					password: '',
					valid: ''
				},
				 
				verificationImg: '',
				ruleValidate: {
					loginId: [{
						required: true,
						message: '用户名是必填项',
						trigger: 'blur'
					}],
					password: [{
						required: true,
						message: '密码是必填项',
						trigger: 'blur' //失去焦点事件
					}],
					valid: [{
						required: true,
						message: '验证码必须填',
						trigger: 'blur'
					}],

				}
			}
		},
		created() {
			//获取后端的session
			// getSession().then(res => {

			// 	let sessionId = res.data.obj;
			// 	console.log("---------:" + sessionId);
			// 	this.$store.commit({
			// 		type: 'initSessionId',
			// 		sessionId
			// 	})

			// 	let temp = this.$store.state.sessionId;
			// 	//调用展示图片的方法
			  	this.changeImage();

			// })
		},
		methods: {
			changeImage() {
				//let temp = this.$store.state.sessionId;
				getValidImage( ).then(res => {
						this.verificationImg = window.URL.createObjectURL(res.data)
					})
					.catch(error => {});
			},
			handleSubmit(name) {
				this.$refs[name].validate((valid) => {
					if (valid) {
						let formdata = {
							username: this.formValidate.loginId,
							password: this.formValidate.password,
							imageCode: this.formValidate.valid,
							//sessionId: this.$store.state.sessionId,

						};
						login(formdata).then(res => {

								//console.log(res.obj);
								if(res.code =='500'){
									this.$Message.error(res.message+',请重新登录');
								}else{
								const userInfo = {
									deptLevelCode: res.obj.deptLevelCode,
									deptName: res.obj.deptName,
									roles: res.obj.roles,
									deptId: res.obj.deptId,
									userName: res.obj.userName,
									userId: res.obj.userId,
									loginId: res.obj.loginId,

								}
								this.$store.commit({
									type: 'initUserInfo',
									userInfo
								})

								this.$Message.success('登录成功!');
								//debugger;
								//登录成功将state放入sessionStorage
								//console.log(JSON.stringify(this.$store.state));
								sessionStorage.setItem("store",JSON.stringify(this.$store.state));
								
								//console.log('1111111:' + this.$store.state.sessionId)
								
								this.$router.push('/')
								//刷新页面让导航栏的内容变化  注册、登录那里
								location. reload();
								}
								
							})
							.catch(error => {
								this.$Message.success(error);
							});


					} else {
						this.$Message.error('数据校验失败，请修改后重新提交!');
					}
				})
			},
			handleReset(name) {
				this.$refs[name].resetFields();
			}



		}

	}
</script>

<style lang="scss" scoped>
	
	.ivu-form-item {
		margin-bottom: 10px;
		margin-top: 10px;
	}
	.bm_h {
		padding: 0 10px;
		height: 50px;
		border-top: 1px solid #FFF;
		border-bottom: 1px solid #e3e2db;
		background: #F2F2F2;
		line-height: 50px;

	}

	.ivu-form-item-label {
		left: 30%;
	}

 

	#userlogin {
		border-style: solid;
		border-width: 1px;
		border-color: #bebdbc;
	}

	#imageId {
		width: 120px;
		height: 30px;
		position: absolute;
		top: 2px;
	}
	
	#weixin-logo {
		border-radius: 3px; //添加圆角
	}

	.ivu-input-wrapper {
		width: 300px;
	}
 
	#weixin-logo {
		width: 30px;
		height: 30px;
		border-radius: 3px; //添加圆角
		position: absolute;
	}

	 
</style>
